import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ACCOUNT } from "../../../api/queryKeys";
import { QueryAccountResponse } from "../../../types";

export const getAccountData = () =>
  api.get<QueryAccountResponse>(QUERY_ACCOUNT).then((res) => res.data);

export default function useGetAccount() {
  return useQuery([QUERY_ACCOUNT], getAccountData);
}
